import { Component, inject, Input, input, SimpleChanges } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { CargarConfService } from '../../../services/cargar-conf.service';
import { GruposLinks } from '../../../interface/data-core';
import { catchError, timeout } from 'rxjs/operators';
import { of } from 'rxjs';
import { MensajesService } from '../../../services/mensajes.service';

@Component({
    selector: 'app-listado-dinamico',
    imports: [CommonModule],
    templateUrl: './listado-dinamico.component.html',
    styleUrl: './listado-dinamico.component.css'
})
export class ListadoDinamicoComponent {

    @Input() public _dataLinks: GruposLinks[] = [];
    @Input() public _labelLinks: string = 'Links dinámicos';

    public _conf = inject(CargarConfService);
    private http = inject(HttpClient);
    private mensajeService = inject(MensajesService);

    public dataLinks: GruposLinks[] = [];

    ngOnInit() {
        console.debug('Listado Dinámico Component Initialized', this._dataLinks);
        this.dataLinks = [...this._dataLinks];
    }

    ngOnDestroy() {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['_dataLinks']) {
            this.dataLinks = [...this._dataLinks];
            console.debug('Listado Dinámico Component Updated', this.dataLinks);

        }
    }
    onOpenUrlTarget(url: string, urlBase: string) {
        let _urlServer = this._conf.localUrl ? '' : (urlBase ?? '');

        switch (this._conf.tiposLinkDinamico) {
            case 1: // Catalogos
                _urlServer = this._conf.localUrl ? '' : (urlBase ?? '');
                break;
            case 2: // Guia docente
                _urlServer = this._conf.localUrl ? '' : (urlBase ?? '');
                break;
            case 3: // Libros externos
                _urlServer = this._conf.localUrl ? '' : (urlBase ?? '');
                break;
            default:
                _urlServer = this._conf.localUrl ? '' : (urlBase ?? '');
                break;
        }

        let _url = `${_urlServer}${url}`;
        console.debug('Validating URL before opening:', _url);

        // Para URLs locales (tipos 1 y 2), abrir directamente sin validación
        if (![1, 2].includes(this._conf.tiposLinkDinamico) && this._conf.localUrl) {
            console.debug('Local URL detected, opening directly:', _url);
            this.mensajeService.showInfo(this._conf.msgLocalUrl);
            return;
        }
        window.open(_url, '_blank');

        return;
        // Para URLs externas, validar accesibilidad
        this.validateUrlAccessibility(_url).then(isAccessible => {
            if (isAccessible) {
                console.debug('URL is accessible, opening:', _url);
                window.open(_url, '_blank');
            } else {
                console.warn('URL is not accessible:', _url);
                this.showUrlErrorMessage(_url);
            }
        });
    }

    private async validateUrlAccessibility(url: string): Promise<boolean> {
        try {
            // Verificar si hay conexión a internet primero
            if (!navigator.onLine) {
                console.warn('No internet connection detected');
                return false;
            }

            // Hacer una petición HEAD para verificar si la URL es accesible
            // Usamos HEAD en lugar de GET para ser más eficiente
            const response = await this.http.head(url, {
                observe: 'response',
                responseType: 'text'
            })
                .pipe(
                    timeout(5000), // Timeout de 5 segundos
                    catchError((error: HttpErrorResponse) => {
                        console.warn('URL validation failed:', error.status, error.message);
                        return of(null);
                    })
                )
                .toPromise();

            return response !== null && response !== undefined && response.status >= 200 && response.status < 400;
        } catch (error) {
            console.warn('Error validating URL accessibility:', error);
            return false;
        }
    }

    private showUrlErrorMessage(url: string) {
        // Mostrar mensaje de error al usuario
        const message = `No se puede acceder al recurso solicitado.\n\nPosibles causas:\n• No hay conexión a internet\n• El recurso no está disponible\n• El servidor está temporalmente fuera de servicio\n\nURL: ${url}`;

        alert(message);

        // Opcional: También log para debugging
        console.error('URL accessibility validation failed for:', url);
    }
}
